// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2ECR5","cell":"ColumnAccessor_cell__14tZM","firstCellAccent":"ColumnAccessor_firstCellAccent__3aA2L"};